export default __webpack_public_path__ + "static/media/temp_thumbnail.7ef21d30.png";